/* eslint-disable */
import * as React from "react";
import { WithStyles, withStyles } from "@material-ui/styles";
import { Tabs, Tab, Box, Typography } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import Footer from "../../../../layouts/Footer";
import Header from "../../../../layouts/Header";
import Layout from "../../../../layouts/Layout";
import { TabPanelProps } from "./types";
import { styles } from "./styles";
import messages from "./messages";
import { UserInfo } from "../../components/UserInfo";
import { UserSettings } from "../../components/UserSettings";
import { useHookSubscribe } from "../../../react-rxjs";
import { userService } from "../../shared";

type Props = WithStyles<typeof styles>;

function TabPanel(props: TabPanelProps) {
  const { currentTab, index, children } = props;

  return (
    <Typography component="div" role="tabpanel" hidden={currentTab !== index}>
      {currentTab === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}

const UserPage: React.FC<Props> = (props: Props) => {
  const { classes } = props;
  const [currentTab, setCurrentTab] = React.useState(0);
  const user = useHookSubscribe(null, userService.user$);
  React.useEffect(() => {
    if (user?.migrationPasswordValid === false && currentTab !== 1) {
      setCurrentTab(1);
    }
  }, [user, currentTab]);

  const handleChangeTab = (e: React.ChangeEvent<{}>, currentTab: number) => setCurrentTab(currentTab);

  return (
    <Layout>
      <Header />
      <div className={classes.root}>
        <Tabs value={currentTab} onChange={handleChangeTab} indicatorColor="primary">
          <Tab key={`tab-user-info`} label={<FormattedMessage {...messages.myProfile} />} />
          <Tab key={`tab-user-settings`} label={<FormattedMessage {...messages.settings} />} />
        </Tabs>
        <TabPanel key={`tabPanel-user-info`} index={0} currentTab={currentTab}>
          <div className={classes.tabPanelRoot}>
            <UserInfo />
          </div>
        </TabPanel>
        <TabPanel key={`tabPanel-user-settings`} index={1} currentTab={currentTab}>
          <div className={classes.tabPanelRoot}>
            <UserSettings />
          </div>
        </TabPanel>
      </div>
      <Footer />
    </Layout>
  );
};

export default withStyles(styles)(UserPage);
